import { RedoMerchantClient } from "@redotech/redo-merchant-app-common/client";
import { CONVERSATIONS_FILTERS_VERSION } from "@redotech/redo-support-common/conversation-filters/conversation-filters";
import { View, viewJsonFormat } from "@redotech/redo-support-common/view";

export const getTeamViews = async (
  client: RedoMerchantClient,
  { signal }: { signal: AbortSignal },
): Promise<View[]> => {
  const v3Header = { "x-api-version": CONVERSATIONS_FILTERS_VERSION };
  const response = await client.client.get("team/views", {
    headers: { ...v3Header, ...client.authorization() },
    signal,
  });

  const rawData = response.data.views;
  const views = rawData.map((view: any) => {
    return viewJsonFormat.read(view);
  });
  return views;
};

export const getUserViews = async (
  client: RedoMerchantClient,
  { signal }: { signal: AbortSignal },
): Promise<View[]> => {
  const v3Header = { "x-api-version": CONVERSATIONS_FILTERS_VERSION };
  const response = await client.client.get("user/support-private-views", {
    headers: { ...v3Header, ...client.authorization() },
    signal,
  });
  const rawData = response.data.views;
  const views = rawData.map((view: any) => {
    return viewJsonFormat.read(view);
  });
  return views;
};
